import { render, staticRenderFns } from "./PackageNum.vue?vue&type=template&id=218db5eb&scoped=true"
import script from "./PackageNum.vue?vue&type=script&lang=js"
export * from "./PackageNum.vue?vue&type=script&lang=js"
import style0 from "./PackageNum.vue?vue&type=style&index=0&id=218db5eb&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218db5eb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('218db5eb')) {
      api.createRecord('218db5eb', component.options)
    } else {
      api.reload('218db5eb', component.options)
    }
    module.hot.accept("./PackageNum.vue?vue&type=template&id=218db5eb&scoped=true", function () {
      api.rerender('218db5eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/cps/views/treety/modules/components/PackageNum.vue"
export default component.exports